import React from "react";
import "./Hero.css";
import AnimatedBanner from "./AnimatedBanner"; // <-- 1. IMPORT THE BANNER

function Hero() {
  return (
    <section id="home" className="hero section">
      <AnimatedBanner />
      {/* Wrap content in a new div with a class for styling */}
      <div className="">
        <div className="hero-content-container container">
          <h1 className="hero-title">Curtis Mullins</h1>
          <p className="hero-subtitle">Software Engineer & Analyst</p>
          <div className="social-links">
            <a href="https://github.com/curtism99" className="social-link">
              GitHub
            </a>
            <a
              href="https://www.linkedin.com/in/curtis-mullins-489193a0/"
              className="social-link"
            >
              LinkedIn
            </a>
            <a
              href="/Curtis-Mullins-Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              Resume (PDF)
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
